import { createApp } from '@app/adapters/create-app'
import WorkflowReviewStatusScreen from './../sections/workflow-review-status-screen'

onDomLoad(function ($dom) {
  $dom.find("[data-behaviour='workflow-review-status']").each(function () {
    const { reviewData, ledgerId, itemClass, itemId } = this.dataset
    const { review, reviews } = JSON.parse(reviewData)

    createApp(WorkflowReviewStatusScreen, {
      review,
      reviews,
      ledgerId: parseInt(ledgerId, 10),
      itemClass,
      itemId: parseInt(itemId, 10),
      shouldRenderContent: this.dataset.shouldRenderContent !== 'false',
      shouldRenderInline: this.dataset.shouldRenderInline === 'true',
    }).mount(this)
  })
})
